<input class="form-control" [(ngModel)]="displayedValue"
       (ngModelChange)="valueUpdated($event)"
       [disabled]="disabled"  />
<div class="error-message" *ngIf="validationError">
  La valeur du paramètre ne respecte pas la règle de validation. Elle n'est donc pas prise en compte.
  <br> Règle de validation : {{parameter?.value_validation}}
</div>